import { useEffect, useState } from "react";
import {
  DRAWER_CONSTANTS,
  PRODUCT_TYPE_CONFIG,
  SCHOOL_DATA_CONSTANTS,
} from "../../constants/schoolData";
import userService from "../../utils/userService";
import { Form, Button, Dropdown, Spinner } from "react-bootstrap";
import { EVENT_NAMES_CONSTANT, logFirebaseEvent } from "../../services/events";
import UserService from "../../utils/userService";
import axios from "axios";
import DrawerComponent from "../Drawer";
import { INPUT_FIELDS_ADM, INPUT_FIELDS, MORE_OPTIONS, DIMENSIONS, INDIA_CENTER_LOCATION, UNIVERSE_VIEW } from "../../constants/Map";
import InputField from "./InputField";
import { Map } from "@vis.gl/react-google-maps";
import Markers from "./Marker";
import moment from 'moment';
import InfoComponent from "../InfoComponent";
import Cardmap from "./Cardmap";
import {ALLOWED_ROLES} from "../../constants/Map"


export default function MapComponent() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [drawerState, setDrawerState] = useState({
    isOpen: false,
    menuItemSelected: "",
  });
  const [inputValues, setInputValues] = useState({
    "p.state": "",
    "p.district": "",
    stage_category: "",
    pin_code: "",
    relationship_w_pearson: "",
    relationship_w_lead: "",
    meeting_scheduled_date: "",
    affiliation__dise: "",
    "p.school_category": "",
    meeting_scheduled_date_operation: "",
    universe_view: "",
    defaultZoom: 4.8,
    "o.email": "",
    'o1.email':""
    

  });
  const [validation, setValidation] = useState('');
  const [latLon, setLatLon] = useState([]);
  const [selectedDimension, setSelectedDimension] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isDateSelected, setIsDateSelected] = useState(false);
  const [dropdown, setDropdown] = useState(INPUT_FIELDS.slice(0,4));
  const [dropdown_NOTADM, setDropdown_NOTADM] = useState(INPUT_FIELDS_ADM.slice(0,5));
  const [userData, setUserData] = useState("");

  const [emailOptions, setEmailOptions] = useState([]);
  const [insideSalesOptions, setinsideSalesOptions] = useState([]);
  






  useEffect(() => {


    const user = userService.getUserData();
    setUserData(user);

   axios.post("https://ada.leadschool.in:443/api/get-users/")  // Adjust API endpoint
      .then(response => {
        setEmailOptions(response.data.results);  // Assuming API returns an array of emails
        console.log(response.data.results);
      })
      .catch(err => {
        console.error("Failed to fetch emails", err);
      })
      ;
  },[])

  useEffect(() => {
  
    const payload = {
      dimensions: [ "o1.email as inside_sales"]
    }

   axios.post("https://ada.leadschool.in:443/api/get-users/", payload) 
      .then(response => {
        
          setinsideSalesOptions(response.data.results);
        
          // Assuming API returns an array of emails
        console.log(response.data.results);
      })
      .catch(err => {
        console.error("Failed to fetch emails", err);
      })
      ;
  },[])

 

  const showUserInfo = () => {
    return (
      <div className='map-user-details-container user-details-container'>
        {windowWidth > 1000 ? (
          <div className='user-info-container'>
            <div>
              <div>
                Welcome, <strong>{`${userData.name}`}</strong>
              </div>
              <div className='role-badge'>{userData.rolename}</div>
            </div>
            <Button className='logout-btn' onClick={handleLogOut}>
              {SCHOOL_DATA_CONSTANTS.btns.logout}
            </Button>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const handleLogOut = () => {
    //firebase log events
    logFirebaseEvent(EVENT_NAMES_CONSTANT.logout_clicked, {
      user_role: UserService.getLogInType()?.rolename || "",
      login_type: UserService.getLogInType(),
    });

    UserService.handleLogout();
  };

  const handleSetDrawerState = (type, value = "") => {
    if (type === DRAWER_CONSTANTS.drawerState) {
      setDrawerState((prev) => ({
        isOpen: !prev.isOpen,
        menuItemSelected: "",
      }));
      return;
    }

    setDrawerState({ ...drawerState, menuItemSelected: value });
  };

  const checkValidDate = (inputDate) => {
    return moment(inputDate).isValid() && new Date(inputDate).getFullYear() > 1900;
  }

  const handleInputValues = (key, value) => {
    setValidation('');
    if (value.includes('Select')) {
      setInputValues({ ...inputValues, [key]: '' });
    } else if (key === 'meeting_scheduled_date') {
      setInputValues({ ...inputValues, [key]: value });
      setIsDateSelected(value !== '');
    } else if (key === 'meeting_scheduled_date_operation') {
      setInputValues({ ...inputValues, [key]: value });
    } else if (/^\d*$/.test(value) && key === 'pin_code') {
      setInputValues({ ...inputValues, [key]: value });
    } else if (key === 'universe_view') {
      setInputValues({
        ...inputValues,
        [key]: value,
        "p.state": "",
        "p.district": "",
        stage_category: "",
        pin_code: "",
        relationship_w_pearson: "",
        relationship_w_lead: "",
        meeting_scheduled_date: "",
        affiliation__dise: "",
        "p.school_category": "",
        meeting_scheduled_date_operation: "",
        "o.email":"",
     "p.insidesaleemail":"",
      });
      setLatLon([]);

      setDropdown_NOTADM(
        dropdown_NOTADM.map((data) => {
          if (data.key === 'p.state') {
            return {...data, visible: !(value == 'tofu')};
          }
          if (userData.rolecode === 'ADM' && data.key === 'o.email') {
            return {...data, visible: true};
          }
          return data;
  
          console.log("NOT ADM:", data);
        })
      );
      

    
      setDropdown(
        dropdown.map((data) => {
          if (data.key === 'p.state') {
            return {...data, visible: !(value === 'tofu')};
          } 
          if (userData.rolecode === 'ADM' && data.key === 'o.email') {
            return {...data, visible: true};
          }
          return data;
        })
      );

    } else if (key !== 'pin_code') {
      setInputValues({ ...inputValues, [key]: value });
    }
    
    
    
  };

  const handleDimension = (value) => {
    setSelectedDimension(value);
  }

  const handleMore = (inputField) => {
    const selectedDD = dropdown.find((data) => data.name === inputField.name);
    if (selectedDD) {
      setDropdown(dropdown.filter((t) => t.name !== inputField.name));
    } else {
      const selectedInputDD = INPUT_FIELDS.find((data) => data.name === inputField.name);
      setDropdown([...dropdown, selectedInputDD])
    }
  }

  const fetchCheckedValue = (value) => {
    const selectedField = dropdown.find((data) => data.name === value.name);
    return !!selectedField;
  }

  const handleSubmit = () => {
    if (
      inputValues['p.state'] === '' &&
      inputValues['p.district'] === '' &&
      inputValues.stage_category === '' &&
      inputValues.pin_code === '' &&
      inputValues.relationship_w_pearson === '' &&
      inputValues.relationship_w_lead === '' &&
      inputValues.meeting_scheduled_date === '' &&
      inputValues.affiliation__dise === '' &&
      inputValues['p.school_category'] === '' &&
      (userData.rolecode === 'ADM' && inputValues['o.email'] === '') &&
      inputValues['1.email'] === ''
      

    ) {
      setValidation("Please select any filter value")
      console.log(setValidation("Please select any filter value"))
      return;
    } 
    // else if ((inputValues.state && inputValues['p.district'] === '') || (inputValues['p.district'] && inputValues.state === '')) {
      // setValidation("Please select State & District") 
      // return;
    // } 
    else if (inputValues.pin_code !== '' && inputValues.pin_code.length < 6) {
      setValidation("Please enter valid Pincode")
      return;
    } else if (isDateSelected && !checkValidDate(inputValues.meeting_scheduled_date)) {
      setValidation("Please enter valid Date")
      return;
    } else {
      setValidation("")
      fetchLatLongInfo(inputValues);
    }
  }


  // const errMessageText = () => {
  //   if (isLoading) return "Loading...";
  //   // if (error?.networkError && error?.networkError?.result) {
  //   //   return (
  //   //     error?.networkError?.result?.error ||
  //   //     SCHOOL_DATA_CONSTANTS.messages.wentWrong
  //   //   );
  //   // }
  //   // if (!!schoolId && !data.length && !loading) {
  //   //   return error?.message || SCHOOL_DATA_CONSTANTS.messages.notAvailable;
  //   // }
  //   if (!(latLon && tylatLon && latLon.length)) {
  //     return SCHOOL_DATA_CONSTANTS.messages.maps.notAvailable;  
  //   }
  //   return SCHOOL_DATA_CONSTANTS.messages.default;
  // };

  const fetchLatLongInfo = async (inputValues) => {
    setIsLoading(true);

    let url = "https://ada.leadschool.in:443/api/udise-deal-mapping/";
    // Unique filters
    let bodyFilters = [{
      field: "agreement_type",
      value: "PE",
      operation: "eq",
      type: "string",
    }];

    if (inputValues['p.state']) {
      bodyFilters = bodyFilters.concat({
        field: "p.state",
        value: inputValues['p.state'],
        operation: "eq",
        type: "string",
      });
    }

    if (inputValues['p.district']) {
      bodyFilters = bodyFilters.concat({
        field: "p.district",
        value: inputValues['p.district'],
        operation: "eq",
        type: "string",
      });
    }

    if (userData) {
      if (userData.rolecode === 'EXC32') {
        // If the user is an Area Manager, pass the Area Manager's email as o.email
        bodyFilters = bodyFilters.concat({
          field: "o.email",
          value: userData.emailid,  // Assuming userData.emailid is the Area Manager's email
          operation: "eq",
          type: "string",
        });
      } else if (userData.rolecode === 'ADM' && !inputValues['o.email']) {
        // For other roles except ADM, pass the user's email if no o.email is provided
        bodyFilters = bodyFilters.concat({
          field: "o.email",
          value: userData.emailid,
          operation: "eq",
          type: "string",
        });
      } else if (inputValues['o.email']) {
        // If o.email is provided in inputValues, use that value
        bodyFilters = bodyFilters.concat({
          field: "o.email",
          value: inputValues['o.email'],
          operation: "eq",
          type: "string",
        });
      }
    }
    
    if (userData) {
      if (userData.rolecode === 'EXP31') {
        console.log(userData.rolecode);
        // If the user is an Sales Manager, pass the Area Manager's email as o.email
        bodyFilters = bodyFilters.concat({
          field: "o1.email",
          value: userData.emailid,  // Assuming userData.emailid is the Area Manager's email
          operation: "eq",
          type: "string",
        });
      } 
    else if (userData && inputValues['p.insidesaleemail']) {
      bodyFilters = bodyFilters.concat({
        field: 'o1.email',
        value: inputValues['p.insidesaleemail'],
        operation: "eq",
        type: "string",
      });
    }}

    if (inputValues?.pin_code?.length === 6) {
      bodyFilters = bodyFilters.concat({
        field: "pin_code",
        value: inputValues.pin_code,
        operation: "eq",
        type: "string",
      });
    }

    if (inputValues.relationship_w_pearson) {
      bodyFilters = bodyFilters.concat({
        field: "relationship_w_pearson",
        value: inputValues.relationship_w_pearson,
        operation: "eq",
        type: "string",
      });
    }

    if (inputValues.relationship_w_lead) {
      bodyFilters = bodyFilters.concat({
        field: "relationship_w_lead",
        value: inputValues.relationship_w_lead,
        operation: "eq",
        type: "string",
      });
    }

    if (inputValues.school_category) {
      bodyFilters = bodyFilters.concat({
        field: "p.school_category",
        value: inputValues['p.school_category'],
        operation: "eq",
        type: "string",
      });
    }

    if (inputValues.stage_category) {
      bodyFilters = bodyFilters.concat({
        field: "stage_category",
        value: inputValues.stage_category,
        operation: "eq",
        type: "string",
      });
    }

    if (inputValues.affiliation__dise) {
      bodyFilters = bodyFilters.concat({
        field: "affiliation__dise",
        value: inputValues.affiliation__dise,
        operation: "eq",
        type: "string",
      });
    }

    if (inputValues.meeting_scheduled_date) {
      const operation = inputValues.meeting_scheduled_date_operation;
      bodyFilters = bodyFilters.concat({
        field: "meeting_scheduled_date",
        value: moment(inputValues.meeting_scheduled_date).format('YYYY-MM-DD'),
        operation,
        type: "string",
      });
    }

    let body = {
      filters: bodyFilters,
      dimensions: [
        "sch_code",
        "schname",
        "lon",
        "lat",
        "affiliation__dise",
        "p.school_category",
        "pin_code",
        "p.district",
        "p.state",
        "sparks_overall",
        "sparks_till_10th_grade",
        "consolidate_sparks_overall",
        "consolidate_sparks_till_10th_grade",
        "category_sparks",
        "relationship_w_lead",
        "relationship_w_pearson",
        "stagelabel",
        "stage_category",
        "meeting_scheduled_date",
        "o.email",
        "o1.email as inside_sales",
        "dealid"

      ],
      universe_view: inputValues.universe_view
    };

    try {
      const config = {
        method: "post",
        url,
        data: body,
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await axios(config);
      const result = res?.data?.results;
      if (result && result.length) {
        setLatLon(
          result.map((data) => ({
            key: JSON.stringify({ sch_code: data.sch_code, lat: data.lat, lng: data.lon }),
            location: { lat: Number(data.lat), lng: Number(data.lon) },
            data,
          })),
        );
      } else {
        setLatLon([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      return null;
    }


  };
  return (
    <div>
      <DrawerComponent
        onClose={() => handleSetDrawerState(DRAWER_CONSTANTS.drawerState)}
        isOpen={drawerState.isOpen}
        onClickMenuItem={handleSetDrawerState}
        handleLogOut={handleLogOut}
        isMobileDevice={windowWidth < 1000}
        menuItemDisabled={false}
        tableColumns={[]}
        handleCheckboxAction={() => null}
      />
      <>
        <div className='top-header-inner-container py-3'>
          <i
            className='fa fa-bars mr-3'
            style={{ color: "black", fontSize: "22px" }}
            role='presentation'
            onClick={() => handleSetDrawerState(DRAWER_CONSTANTS.drawerState)}
          ></i>
          <img className='lead-logo' src={PRODUCT_TYPE_CONFIG[0].logo} alt='lead-logo'></img>
          {showUserInfo()}
        </div>
        <div style={{ paddingTop: "90px" }} className='map-input-container'>
        <Form.Group className="map-input-fields-group">
            <div className="map-input-label">Universe: </div>
            <Form.Control
                as='select'
                key='universe_view'
                onChange={(e) => {handleInputValues('universe_view', e.target.value)}}
                value={inputValues['universe_view']}
                className='map-input-field'
              >
                <option value={""}>Select Universe View</option>
                {UNIVERSE_VIEW.map(ddInfo => (
                      <option value={ddInfo.value}>{ddInfo.label}</option>
                  ))
                }
              </Form.Control>

          </Form.Group>
          {inputValues.universe_view && <>
            <Form.Group className="map-input-fields-group">
              <div className="map-input-label">Filter: </div>

{userData.rolecode === 'ADM'?( dropdown.map(ddInfo => {
  // Check if the user's role is ADM
  const showForADM = userData.rolecode === 'ADM';

  // Conditionally handle Email dropdown
  if (ddInfo.name === 'Email' && !showForADM) {
    return null; // Don't render Email dropdown if not ADM
  }

  // Conditionally handle InsideSale dropdown
  if (ddInfo.name === 'InsideSale' && !showForADM) {
    return null; // Don't render InsideSale dropdown if not ADM
  }
 
  
  

  // Populate Email options if role is ADM
  if (ddInfo.name === 'Email' && showForADM) {
  
    ddInfo.data = emailOptions;
  }
  console.log("ADM: ", ddInfo)
  // Populate InsideSale options if role is ADM
  if (ddInfo.name === 'InsideSale' && showForADM) {
    const filteredOptions = insideSalesOptions.filter(option => option !== null);
    ddInfo.data = filteredOptions;
  }
                if (ddInfo.visible) {
                    return <>
                      <InputField
                        fieldInfo={ddInfo}
                        handleInputValues={handleInputValues}
                        inputValues={inputValues}
                        key={ddInfo.key}
                        isDateSelected={isDateSelected}
                      ></InputField>
                    </> 
                  }
                })
                
              
):( dropdown_NOTADM.map(ddInfo => {


  

console.log("NON-ADM",ddInfo)
  // Conditionally handle Email dropdown
  
                if (ddInfo.visible) {
                    return <>
                      <InputField
                        fieldInfo={ddInfo}
                        handleInputValues={handleInputValues}
                        inputValues={inputValues}
                        key={ddInfo.key}
                        isDateSelected={isDateSelected}
                      ></InputField>
                    </> 
                  }
                })
              
)}
              
             
              {/* More */}

              {/* {(userData.rolecode !== 'ADM')?
                
              } */}
            {/* <Dropdown>
              <Dropdown.Toggle className="map-input-dd-btn">
                More
              </Dropdown.Toggle>
              <Dropdown.Menu className="map-input-dd-menu">
                {
 INPUT_FIELDS.filter(t => !t.isSelected).map((option, index) => (
  <Form.Group key={index} controlId={`checkbox-${index}`} className="map-input-checkbox">
    <Form.Check
      key={index}
      type="checkbox"
      className="map-input-checkbox"
      label={option.name}
      onChange={() => handleMore(option)}
      checked={fetchCheckedValue(option)}
    />
  </Form.Group>
                ))}
              </Dropdown.Menu>
            </Dropdown> */}
            {userData.rolecode === 'ADM' ? (
 <Dropdown>
 <Dropdown.Toggle className="map-input-dd-btn">
   More
 </Dropdown.Toggle>
 <Dropdown.Menu className="map-input-dd-menu">
   {INPUT_FIELDS.filter(t => !t.isSelected).map((option, index) => (
     <Form.Group key={index} controlId={`checkbox-${index}`} className="map-input-checkbox">
       <Form.Check
         key={index}
         type="checkbox"
         className="map-input-checkbox"
         label={option.name}
         onChange={() => handleMore(option)}
         checked={fetchCheckedValue(option)}
       />
     </Form.Group>
   ))}
 </Dropdown.Menu>
</Dropdown>
    
) : (
 null
)}


            

            </Form.Group>
            {userData.rolecode === 'ADM'?( dropdown.find(t => t.key === 'meeting_scheduled_date') && <Form.Group className='map-input-fields-group'>
                <span className="map-date-placeholder">Enter Meeting Scheduled Date:</span>
                <Form.Control
                    key='meeting_scheduled_date'
                    type='date'
                    onChange={(e) => {handleInputValues('meeting_scheduled_date', e.target.value)}}
                    value={inputValues['meeting_scheduled_date']}
                    className='map-input-field'
                >
                </Form.Control>
                <Form.Control
                    disabled={!isDateSelected}
                    as='select'
                    key='meeting_scheduled_date_operation'
                    onChange={(e) => {handleInputValues('meeting_scheduled_date_operation', e.target.value)}}
                    value={inputValues['meeting_scheduled_date_operation']}
                    className='map-input-field'
                >
                    <option value={""}>Select Operation</option>
                    <option value={"lte"}>Less Than or Equal</option>
                    <option value={"eq"}>Equal</option>
                    <option value={"gte"}>Greater Than or Equal</option>
                </Form.Control>
            </Form.Group>): (<Form.Group className='map-input-fields-group'>
                <span className="map-date-placeholder">Enter Meeting Scheduled Date:</span>
                <Form.Control
                    key='meeting_scheduled_date'
                    type='date'
                    onChange={(e) => {handleInputValues('meeting_scheduled_date', e.target.value)}}
                    value={inputValues['meeting_scheduled_date']}
                    className='map-input-field'
                >
                </Form.Control>
                <Form.Control
                    disabled={!isDateSelected}
                    as='select'
                    key='meeting_scheduled_date_operation'
                    onChange={(e) => {handleInputValues('meeting_scheduled_date_operation', e.target.value)}}
                    value={inputValues['meeting_scheduled_date_operation']}
                    className='map-input-field'
                >
                    <option value={""}>Select Operation</option>
                    <option value={"lte"}>Less Than or Equal</option>
                    <option value={"eq"}>Equal</option>
                    <option value={"gte"}>Greater Than or Equal</option>
                </Form.Control>
            </Form.Group>)}



            <Form.Group className='map-input-fields-group'>
            <div className="map-input-label">Dimension: </div>
              <Form.Control
                as='select'
                aria-label='Select Dimension'
                onChange={(e) => handleDimension(e.target.value)}
                value={selectedDimension}
                className='map-input-field'
              >
                <option>Select Dimension</option>
                {DIMENSIONS.map((t) => (
                  <option>{t}</option>
                ))}
              </Form.Control>
              <Button
                type='button'
                onClick={(e) => handleSubmit()}
                value={selectedDimension}
                className="map-input-dd-btn-submit"
              >
                Submit
              </Button>
            </Form.Group>
            <span style={{color: "red"}}>{validation ? `* ${validation}` : ''}</span>
          </>}
        </div>

        {isLoading ? (
          <div className="spinner-container">
            <Spinner className='common-spinner' variant="primary" animation='border' size='lg' />
          </div>

        ) : (
       
          
          <div className="map-view" style={{ height: "100vh", width: "100%" }} >
          {/* {(!latLon.length || isLoading) && (
            <InfoComponent message={errMessageText()} />
          )} */}
          
          
          <Map
 

            mapId='greenfieldmapid'
            defaultZoom={4.8}
            // zoom={inputValues.defaultZoom}
            // center={inputValues.state.latLon}
            defaultCenter={INDIA_CENTER_LOCATION}
          // defaultCenter={ getDefaultCenterPosition() }
          // onCameraChanged={ (ev) =>
          // console.log('camera changed:', ev.detail.center, 'zoom:', ev.detail.zoom)
          // }
          >
            {/* <Card/> */}
            
          
            <Markers  latlonData={latLon} selectedDimension={selectedDimension}/>
                   
        
          </Map>
         
          <div>
          <Cardmap latlonData={latLon} selectedDimension={selectedDimension}  />
          </div>
          
        </div>
        

        
        )}
      </>
    </div>
  );
}



